/* import __COLOCATED_TEMPLATE__ from './add-external-account.hbs'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { action, computed, set } from '@ember/object';
import { and } from '@ember/object/computed';
import { later } from '@ember/runloop';
import { scrollToFirstError } from '@square/ember-prism/utils/error-scrolling';
import validRoutingNumber from '@banking/ui/utils/valid-routing-number';
import { BankAccountType } from '@square/dashboard-protos/models/squareup/bank-accounts/bank_accounts';
let AddExternalAccount = (_dec = and('routingNumberValidation.isValid', 'accountNumberValidation.isValid', 'confirmAccountNumberValidation.isValid'), _dec2 = computed('routingNumber'), _dec3 = computed('accountNumber'), _dec4 = computed('confirmAccountNumber', 'accountNumber'), (_class = class AddExternalAccount extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "sfsCustomerApi", _descriptor2, this);
    _initializerDefineProperty(this, "sfsExternalBankAccountApi", _descriptor3, this);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "routingNumber", '');
    _defineProperty(this, "accountNumber", '');
    _defineProperty(this, "confirmAccountNumber", '');
    _defineProperty(this, "isLoading", false);
    _defineProperty(this, "accountTypeOptions", [{
      value: BankAccountType.CHECKING,
      label: this.intl.t('banking.enums.accounts.CHECKING')
    }, {
      value: BankAccountType.SAVINGS,
      label: this.intl.t('banking.enums.accounts.SAVINGS')
    }, {
      value: BankAccountType.BUSINESS_CHECKING,
      label: this.intl.t('banking.enums.accounts.BUSINESS_CHECKING')
    }]);
    _defineProperty(this, "accountType", this.accountTypeOptions[0].value);
    _initializerDefineProperty(this, "isValid", _descriptor4, this);
  }
  get routingNumberValidation() {
    const isValid = validRoutingNumber(this.routingNumber);
    return {
      isValid,
      isInvalid: !isValid,
      message: this.intl.t('sfs.shared.transfers.addBankAccount.routingNumberInvalid')
    };
  }
  get accountNumberValidation() {
    const isValid =
    // CorePro limits account numbers to a max of 17 digits
    this.accountNumber !== '' && this.accountNumber.match(/^\d{1,17}$/);
    return {
      isValid,
      isInvalid: !isValid,
      message: this.intl.t('sfs.shared.transfers.addBankAccount.accountNumberInvalid')
    };
  }
  get confirmAccountNumberValidation() {
    const isValid = this.confirmAccountNumber !== '' && this.accountNumber === this.confirmAccountNumber;
    return {
      isValid,
      isInvalid: !isValid,
      message: this.intl.t('sfs.shared.transfers.addBankAccount.confirmAccountNumberInvalid')
    };
  }
  async onSubmit() {
    if (this.isValid) {
      set(this, 'isLoading', true);
      try {
        const bankAccount = await this.sfsExternalBankAccountApi.linkExternalBankAccount({
          customerId: this.sfsCustomerApi.currentCustomer.id,
          primaryBankIdentificationNumber: this.routingNumber,
          accountNumber: this.accountNumber,
          accountType: this.accountType
        });
        this.selectBankAccount(bankAccount);
      } catch (error) {
        this.onLinkError(error);
      } finally {
        set(this, 'isLoading', false);
      }
    } else {
      // This is in a runloop because the error classes have not yet rendered
      later(() => {
        // Tests can remove the elements before `later` fires
        const modal = document.querySelector('.sfs-bank-selector__modal');
        if (modal) {
          scrollToFirstError(modal);
        }
      });
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sfsCustomerApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sfsExternalBankAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isValid", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "routingNumberValidation", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "routingNumberValidation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "accountNumberValidation", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "accountNumberValidation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirmAccountNumberValidation", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "confirmAccountNumberValidation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSubmit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSubmit"), _class.prototype)), _class));
export { AddExternalAccount as default };